var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeRank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "url(#paint0_linear)",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3463 11.737C11.5032 11.737 11.6272 11.7809 11.7183 11.8689C11.8093 11.9536 11.8548 12.0666 11.8548 12.2079V13.0555H7.03273V12.5846C7.03273 12.4936 7.05157 12.3963 7.08924 12.2927C7.12692 12.1891 7.19284 12.0949 7.28702 12.0101L9.26484 10.0182C9.43437 9.84865 9.58192 9.68697 9.7075 9.53314C9.83307 9.37931 9.93667 9.22862 10.0183 9.08107C10.0999 8.93038 10.1611 8.78126 10.202 8.63371C10.2428 8.48301 10.2632 8.32447 10.2632 8.15809C10.2632 7.88496 10.1972 7.67619 10.0654 7.53178C9.93667 7.38423 9.73889 7.31045 9.47204 7.31045C9.25542 7.31045 9.07177 7.36853 8.92108 7.48469C8.77353 7.5977 8.6715 7.73898 8.61499 7.90851C8.54906 8.08117 8.46273 8.19576 8.35599 8.25227C8.24925 8.30878 8.09699 8.32134 7.89921 8.28994L7.12692 8.15338C7.17715 7.81118 7.2729 7.51294 7.41417 7.25865C7.55858 7.00436 7.73596 6.79245 7.9463 6.62292C8.15978 6.4534 8.40308 6.32782 8.67621 6.2462C8.94933 6.16143 9.24287 6.11905 9.55681 6.11905C9.89586 6.11905 10.2004 6.16928 10.4704 6.26974C10.7435 6.36706 10.9758 6.50363 11.1673 6.67943C11.3588 6.85524 11.5048 7.06558 11.6053 7.31045C11.7089 7.55218 11.7607 7.81903 11.7607 8.111C11.7607 8.36215 11.7246 8.59446 11.6524 8.80794C11.5833 9.02142 11.4875 9.22548 11.3651 9.42012C11.2427 9.61163 11.0998 9.79842 10.9366 9.98051C10.7765 10.1595 10.6054 10.3415 10.4233 10.5268L9.08119 11.9018C9.25386 11.8484 9.42495 11.8076 9.59448 11.7794C9.76401 11.7511 9.92098 11.737 10.0654 11.737H11.3463Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 5.03271,
    y: 5.11902,
    width: 8.82211,
    height: 10.9365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.5,
    y1: 0,
    x2: 9.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeRank2);
export default __webpack_public_path__ + "static/media/badge-rank-2.a050facc2eeeaf130544664bdf60aa7c.svg";
export { ForwardRef as ReactComponent };